import React,{useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom'
import CommonTermsAndConditions from '../../component/CommonTermsAndConditions'
const TermsAndConditions = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
    return (
        <>
            <section className="hero-area hero-area-background">
                <div className="container">
                    <div className="text-center px-20">
                        <div className="section-heading">
                            <div className="title-wrapper">
                                <h2 className="section-title has_fade_anim fs-4x  text-grad-1 pb-6">
                                    Terms & Conditions
                                </h2>
                                {/* <p className=''>
                                    <Link to='/' className='fw-bold fs-4'>HOME </Link>
                                    <span className='me-2'>
                                        <i className="fa-solid fa-arrow-right fs-4"></i>
                                    </span>
                                    <span className='fs-4'>Terms & Conditions</span>
                                </p> */}
                            </div>
                            {/* <div className="text-wrapper">
                                <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                                    We’d love to talk to you. After all, we are in the business of conversations.
                                </p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            <section className='container'>
                <div className='row mt-10'>
                    <div className='col-md-12'>
                        <CommonTermsAndConditions/>
                    </div>
                </div>
            </section>
        </>
        
    )
}

export {TermsAndConditions}